// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    font-family: "Nunito Sans", sans-serif;
    background-color: #f5f5f5;
}

.page-container {
    height: 100vh;
    width: 100vw;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
}

.page-info {
    height: auto;
    width: auto;
    margin-bottom: 25px;
}

.page-title {
    width: 100%;
}

.page-title p {
    text-align: center;
    font-size: 70px;
    color: #bdbdbd;
    font-weight: bold;
    letter-spacing: 10px;
    margin: 0 0 25px;
}

.page-description p {
    margin: 0;
    text-align: center;
    font-size: 30px;
    color: #454545;
    font-weight: bold;
    word-spacing: 5px;
}

.page-info-image {
    width: 100%;
    text-align: center;
}

.page-info-image img {
    width: 150px;
    height: 150px;
    text-align: center;
    margin-bottom: 10px;
}

.page-description {
    margin: 20px;
}

.install-promo {
    width: 100%;
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    position: fixed;
    display: none;
    align-items: center;
    background-color: #ffffff;
    bottom: 0;
    left: 0;
}

.install-promo img {
    width: 15%;
    height: 15%;
    margin-left: 10px;
    margin-right: 10px;
}

.install-promo-title {
    width: 100%;
    color: #212121;
    font-size: 20px;
}

.install-promo-description {
    width: 100%;
    text-align: left;
    margin-top: 3px;
    color: #424242;
    font-size: 12px;
}

.install-promo-button {
    width: 20%;
    height: auto;
    padding: 8px;
    margin-right: 10px;
    text-align: center;
    color: #212121;
    border-radius: 12px;
    border: 1px solid #329D58;
    font-size: 16px;
}

.install-promo-button:active {
    background-color: #64b5f6;
}

@media only screen and (max-width: 600px) {
    .page-title p {
        font-size: 32px;
    }

    .page-description p {
        font-size: 25px;
    }

    .install-promo {
        display: flex;
    }
}`, "",{"version":3,"sources":["webpack://./src/status-page/css/status.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    font-family: \"Nunito Sans\", sans-serif;\n    background-color: #f5f5f5;\n}\n\n.page-container {\n    height: 100vh;\n    width: 100vw;\n    margin: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.page-info {\n    height: auto;\n    width: auto;\n    margin-bottom: 25px;\n}\n\n.page-title {\n    width: 100%;\n}\n\n.page-title p {\n    text-align: center;\n    font-size: 70px;\n    color: #bdbdbd;\n    font-weight: bold;\n    letter-spacing: 10px;\n    margin: 0 0 25px;\n}\n\n.page-description p {\n    margin: 0;\n    text-align: center;\n    font-size: 30px;\n    color: #454545;\n    font-weight: bold;\n    word-spacing: 5px;\n}\n\n.page-info-image {\n    width: 100%;\n    text-align: center;\n}\n\n.page-info-image img {\n    width: 150px;\n    height: 150px;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.page-description {\n    margin: 20px;\n}\n\n.install-promo {\n    width: 100%;\n    height: auto;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    position: fixed;\n    display: none;\n    align-items: center;\n    background-color: #ffffff;\n    bottom: 0;\n    left: 0;\n}\n\n.install-promo img {\n    width: 15%;\n    height: 15%;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.install-promo-title {\n    width: 100%;\n    color: #212121;\n    font-size: 20px;\n}\n\n.install-promo-description {\n    width: 100%;\n    text-align: left;\n    margin-top: 3px;\n    color: #424242;\n    font-size: 12px;\n}\n\n.install-promo-button {\n    width: 20%;\n    height: auto;\n    padding: 8px;\n    margin-right: 10px;\n    text-align: center;\n    color: #212121;\n    border-radius: 12px;\n    border: 1px solid #329D58;\n    font-size: 16px;\n}\n\n.install-promo-button:active {\n    background-color: #64b5f6;\n}\n\n@media only screen and (max-width: 600px) {\n    .page-title p {\n        font-size: 32px;\n    }\n\n    .page-description p {\n        font-size: 25px;\n    }\n\n    .install-promo {\n        display: flex;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
